// ======================================================================
// File Name       : MultiLanguageListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as MultiLanguageAction from '../../actions/MultiLanguageAction';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import ModalConductor from '../../components/modal/ModalConductor';
import MultiLanguageList from '../../components/multiLanguage/MultiLanguageList';
import MultiLanguageSearch from '../../components/multiLanguage/MultiLanguageSearch';
import * as actionType from '../../constants/actionTypes/page';
import { RETURN_MAX_NUM } from '../../constants/index';
import { MULTI_LANGUAGE_EDIT, MULTI_LANGUAGE_LIST } from '../../constants/PathConstants';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class MultiLanguageListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      isAllowShowSearchMessage: false,
    };
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.initData = this.initData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.goToEdit = this.goToEdit.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: MULTI_LANGUAGE_LIST,
      searchCondition: formValues,
    });
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.documentTranslateSortType) {
        column = initialValues.documentTranslateSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, column, startPosition);
    this.props.dispatch(MultiLanguageAction.searchMultiLanguageList(param));
  }

  /**
   * Handle sort table
   */
  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = null;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  searchData(startPosition, column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    const paramSearch = this.createParams(formValues, column, startPosition);
    this.props.dispatch(MultiLanguageAction.searchMultiLanguageList(paramSearch))
    .then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  createParams(data, column, startPosition) {
    const filterData = {};

    if (data && data.contentSecernId) {
      filterData.contentSecernId = data.contentSecernId;
    }

    if (data && data.contentName) {
      filterData.contentName = data.contentName;
    }

    if (data && data.multiLanguageStatus) {
      filterData.multiLanguageStatus = parseInt(data.multiLanguageStatus, 10) < 0 ? null : parseInt(data.multiLanguageStatus, 10);
    }

    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }

    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.documentMultiLanguageSortType = column.sortBy;
    }

    if (!column) {
      filterData.ascendingDescendingSort = null;
      filterData.documentMultiLanguageSortType = null;
    }

    if (!startPosition) {
      filterData.startPosition = 0;
    }
    filterData.returnMaxNum = RETURN_MAX_NUM;
    const param = {
      searchInfo: filterData,
    };
    return param;
  }

  goToEdit(contentSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: MULTI_LANGUAGE_LIST,
        searchCondition: formValues,
      });
    }
    const path = MULTI_LANGUAGE_EDIT.replace(':id', contentSecernId);
    this.props.history.push(path);
  }

  clickSearchButton() {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    this.props.dispatch(showLoading());
    const filterData = {
      ...this.state.filterData,
      contentSecernId: formValues.contentSecernId,
      contentName: formValues.contentName,
      multiLanguageStatus: formValues.multiLanguageStatus,
      documentMultiLanguageSortType: formValues.documentMultiLanguageSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      startPosition: formValues.startPosition,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('documentMultiLanguageSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(MultiLanguageAction.searchMultiLanguageList(paramSearch))
      .then(() => {
        this.props.dispatch(hideLoading());
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.documentMultiLanguageSortType) {
      column = formValues.documentMultiLanguageSortType;
    }
    this.searchData(startPosition, column);
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { invalid, documentMultiLanguageList, checkedContent, recordNum } = this.props;
    const { allSecernIds } = documentMultiLanguageList;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={allSecernIds}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <MultiLanguageSearch
          {...this.state.filterData}
          recordNum={recordNum || 0}
          onSearchBtnClick={this.clickSearchButton}
        />
        <MultiLanguageList
          documentMultiLanguageList={documentMultiLanguageList}
          handleSortState={this.handleSortState}
          goToEdit={this.goToEdit}
          invalid={invalid}
          recordNum={recordNum || 0}
          getStartEndData={this.getStartEndData}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <ModalConductor
          formKey="multiLanguageListForm"
          history={this.props.history}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const invalid = isInvalid('multiLanguageListForm')(state);
  let { filterData } = state.multiLanguage;
  const { checkedContent, documentMultiLanguageList, recordNum } = state.multiLanguage;
  const { parentPath, searchCondition } = state.page;
  const { multiLanguageListForm } = state.form;
  filterData = multiLanguageListForm && multiLanguageListForm.values ?
    multiLanguageListForm && multiLanguageListForm.values : filterData;
  let initial = filterData;
  if (parentPath === MULTI_LANGUAGE_LIST) {
    const paramSearch = {};
    if (searchCondition) {
      paramSearch.contentSecernId = searchCondition.contentSecernId;
      paramSearch.contentName = searchCondition.contentName;
      paramSearch.multiLanguageStatus = searchCondition.multiLanguageStatus;
      paramSearch.documentMultiLanguageSortType = searchCondition.documentMultiLanguageSortType;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.startPosition = searchCondition.startPosition;
    }
    initial = paramSearch;
  }

  return {
    documentMultiLanguageList,
    recordNum,
    invalid,
    initialValues: initial,
    formValues: getFormValues('multiLanguageListForm')(state),
    searchCondition,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'multiLanguageListForm',
  touchOnChange: true,
})(MultiLanguageListContainer));
